import { ModelApiService } from './BaseApiService'

export default class StaffApiService extends ModelApiService {
  constructor() {
    super('Staff')
  }

  async loadDivisionTree() {
    return await this.get(`DivisionTree`)
  }

  async loadOrganisationTree() {
    return await this.get(`organisation-tree`)
  }

  async loadTreeFlat() {
    return await this.get(`DivisionTreeFlat`)
  }

  async loadManagerTree() {
    return await this.get(`ManagerTree`)
  }

  async loadAdminClientLocationTree(adminIds) {
    return await this.get(`AdminClientLocationTree`, {
      ids: adminIds.join(','),
    })
  }

  async loadAllAdmins() {
    return await this.get(`AdminDetails`)
  }
}
